import {cDisplay} from '../creator/cDisplay'
import { speechBubble } from "../creator/cDisplayObjects/speechBubble";
import { cGame } from "../creator/cGame";
import { cButton } from '../creator/cGameObjects/cButton';
import { cContainer } from '../creator/cGameObjects/cContainer';
import { cInlineDisplay } from '../creator/cGameObjects/cInlineDisplay';
import { cSprite } from '../creator/cGameObjects/cSprite';
import { cText } from "../creator/cGameObjects/cText";
import {cScene} from '../creator/cScene'
import { ScreenItem } from '../creator/dataTypes';
import { getStr } from "../creator/utils/simpleLocalisation";



export class gameWahlomat extends cDisplay {

  private quotes:string[]
  private quoteData:any
  private curQuoter:string
  private curQuestion:any
  private questionIdx: number
  private results:number[]

  private speakIDD: any

  private selectedParty: string
  private parties: string []

  init(){
    super.init()
    console.log('INIT WHALOMAT')
    var cS = this.scene as cScene;
    this.questionIdx = -1
    this.results = [0,0,0,0,0]
    this.quotes = ['bunten','dss','pas','qpd','tuba','ulf']
    this.parties = ['ULF','Bunten','PAS','QPD','DSS'];
    Phaser.Utils.Array.Shuffle(this.quotes);

    (this.scene as cScene).ev.addListener('action',(a,b,c)=>{
      switch (b.command){
        case 'speak':
          if (!b.payload.inline){
            this.getByName('coinHolder').visible = false
            this.getByName('questionHolder').visible = false
            this.getByName('faceHolder').visible = true
            this.getByName('faceMouth').visible = true
            this.getByName('faceButton').visible = false
            this.getByName('faceText').visible = true
          }

          var itemName = b.payload.tg ? b.payload.tg : 'faceMouth'

          var n = this.getByName(itemName)
          var cc = (Number(b.payload.msg.length / 1.5))
          var $this  = this
          n.frameName = 'mouth_1'


          const postAction = ()=>{
            if (b.payload.action){
              var cb:cButton = this.getByName('faceButton')
              cb.visible = true
              cb.events.removeAllListeners();
              cb.events.once('click',()=>{
                ($this.scene as cScene).triggerSceneEvent(b.payload.action)                  
                if (b.payload.hideBtn === true){
                  cb.visible = false
                }else{
                  this.getByName('faceHolder').visible = false;
                }
              })
            }            
          }

          var str = '';
          if (!b.payload.inline){
            if (b.payload.result == 'party'){

              if (!this.selectedParty){
                this.selectedParty = cGame.current.state.get('2::selected_party')
              }

              //str =   this.quoteData.names[this.selectedParty]
              str =  getStr( String('partei.'+this.selectedParty).toLowerCase())

              
            }else{
               str = getStr(b.payload.msg)
            }
          }
          this.getByName('faceText').textdata = str;

          if (!str) return

          if (cGame.current.state.get('voiceover',null) === 'on' && str){
            var s = getStr(String(str).trim());                
            var $this = this;  

            speechBubble.voiceOver.speak(s,'w-o-mat',function(){
              console.log('TRIGGER')
              $this.stopTalk(n);
              if (b.payload.completedmsg){
                ($this.scene as cScene).triggerSceneEvent('completed',{'completed_step':b.payload.completedmsg})
              }else{
                postAction();
              }              
            })
            this.talk(n,-1,null); 
          }else{
            this.talk(n,cc,()=>{
              postAction();
            });
          }
          break;

        case 'init_quotes':
          this.curQuoter = this.quotes.pop();          
          if (this.curQuoter){
            (cS.getByName('screenText') as cText).setText( this.quoteData.badges[ this.curQuoter ] )
            cS.triggerSceneEvent('new_quote')
          }else{
            cS.triggerSceneEvent('coin_completed')
          }
          break;

        case 'handle_drop':
          var [n,drag] = b.payload.drag.split('_')
          var drop:cSprite =  cS.getByName(b.payload.drag) as cSprite
          var tg = cS.getByName('coinslot') as cSprite

          if (drag == this.curQuoter){
            drop.visible = false
            drop.modules.drag.enabled = false
            cS.triggerSceneEvent('next')
          }else{
            tg.dragitem = [];
            cS.triggerSceneEvent('error');
            (drop as cSprite).modules.drag.returnToOrigin()
          }
          break;


        case 'next_question':
          this.questionIdx++;

          if (this.questionIdx === 10){
            var idx = 0;
            var max = 0;
            this.results.forEach( (v,i)=>{
              if (v > max) {
                idx = i
                max = v
              }
            } )

            this.selectedParty = this.parties[idx];          
            cGame.current.state.set('2::selected_party',this.selectedParty)
            
            //cGame.current.state.set('2::selected_party_name', this.quoteData.names[this.selectedParty])
            cGame.current.state.set('2::selected_party_name', getStr( String('partei.'+this.selectedParty).toLowerCase()))
            
            cS.triggerSceneEvent('completed',{selected:this.selectedParty})

            return
          }
          this.curQuestion = this.quoteData.questions[ this.questionIdx ];
          (cS.getByName('questionText') as cText).textdata =  this.curQuestion.q

          var n = this.getByName('questionfaceMouth')
          if (cGame.current.state.get('voiceover',null) === 'on'){
            var s = getStr(String(this.curQuestion.q).trim());
            this.talk(n,-1,null);
            speechBubble.voiceOver.speak(s,'w-o-mat',()=>{
              this.stopTalk(n);
            })
          }

          break;
        case 'answer':

          var weight = this.curQuestion.weight.split('');
          var curResult = [0,0,0,0,0]
          weight.forEach( (v,i)=>{
            var ad:number = 0
            var answer = Number(b.payload.answer);
            switch (v){
              case '+': 
                if (answer == 1 ){
                  ad = 2;
                }else if (answer == 3){
                  ad = -1;
                }
                break
              case 'x':
                if (answer == 3){
                  ad = 2
                }else if (answer == 1){
                  ad = -1
                }
                break
              case '.':
                if (answer == 2 ){
                  ad = 1;
                }
                break;
              default:
                break;
            }            
            curResult[i] += ad
          })
          console.log('>>',curResult);

          //apply results
          curResult.forEach((val,i)=>this.results[i] += val)


          var db = {
            q: this.curQuestion.q,
            w: this.parties.map( (pname,i)=>pname +'='+ this.curQuestion.weight[i]),
            res: this.parties.map( (pname,i)=>pname +'='+ curResult[i]),
            total: this.parties.map( (pname,i)=>pname +'='+ this.results[i]),
          }


          var tt:cText = this.getByName('DEBUGTEXT');
          console.log(tt);
          tt.textdata = JSON.stringify(db,null,2);

          
          cS.triggerSceneEvent('next_question')
          console.log(this.results)
          break;
      }
    })
  }


  talk(ref,cc,cb){    
    clearInterval(this.speakIDD);
    this.speakIDD = setInterval(()=>{
      ref.frameName = 'mouth_'+Math.floor( Math.random() * 3);
      if (cc != -1) cc--;
      if (cc != -1 && cb){
        this.stopTalk(ref);
        cb();
      }
    },100);
  }

  stopTalk(ref){
    clearInterval(this.speakIDD);
    ref.frameName = 'mouth_0'
  }


  buildScene(){    
    var cS = this.scene as cScene;
    super.buildScene();

    setTimeout(()=>{
      this.quoteData = (cS.getByName('DATA') as cContainer).modules.data._extraData
      console.log(this.quoteData)
    },1)
  }
}
